import { Area } from '@alltrails/shared/types/area';
import { Trail as SharedTrail, TrailId, TrailPhoto, SEOTrailBase } from '@alltrails/shared/types/trail';
import { Activities } from './Activities';
import { AreaId, AreaNames, CityId, CityNames, CountryId, CountryNames, StateId, StateNames } from '../Location';
import GeoLocation from '../Location/GeoLocation';
import { Features } from './Features';
import { ObjectId, ObjectNames, ObjectDescriptions } from '../Object';
import RouteType from './RouteType';
import TrailType from './TrailType';
import { UnitType } from './UnitType';
import { VisitorUsage } from './VisitorUsage';
import { HighlightResult } from '../Search';
import { AreaSlug } from '../Slugs';

type AllNames = AreaNames & CityNames & CountryNames & StateNames & ObjectNames & ObjectDescriptions;

type GarminCourse = {
  course_id: number;
  updated_at: string;
};

type Trail = AllNames &
  SEOTrailBase & {
    abbrev_desc_i?: string;
    abbrev_desc_m?: string;
    activities: Activities[];
    adjustedPopularity?: number;
    area_id?: AreaId;
    area_slug?: AreaSlug;
    area_type?: 'N'; // see location_info_holder.js
    avg_rating: number;
    city_id?: CityId;
    city_url?: string;
    country_id?: CountryId;
    difficulty_rating?: string;
    duration_minutes: number;
    duration_minutes_cycling: number;
    duration_minutes_hiking: number;
    duration_minutes_mountain_biking: number;
    duration_minutes_trail_running: number;
    elevation_gain: number;
    features?: Features[];
    garminCourse?: GarminCourse;
    has_profile_photo: boolean;
    ID: number; // verified on 2022-03-31
    length: number;
    num_photos: number;
    num_reviews: number;
    objectID: ObjectId;
    overview: string | null;
    popularity: number;
    park_name?: string;
    profile_photo_data: string;
    route_type: RouteType;
    slug: string;
    state_id: StateId;
    trail_id: TrailId;
    type: TrailType;
    units: UnitType;
    verified_map_id?: number;
    visitor_usage: VisitorUsage;
    _geoloc: GeoLocation; // verified on 2022-03-31 as lowercase l
    _highlightResult?: HighlightResult;
  };

const sharedTrailFromTrail = (trail: Trail): SharedTrail => ({
  id: trail.ID,
  name: trail.name,
  slug: trail.slug,
  area: { name: trail.area_name, slug: trail.area_slug } as Area,
  avgRating: trail.avg_rating,
  defaultActivityStats: { difficulty: Number(trail.difficulty_rating), rating: trail.avg_rating },
  defaultPhoto: trail.has_profile_photo || trail.profile_photo_data ? ({} as TrailPhoto) : undefined,
  trailCounts: { reviewCount: trail.num_reviews },
  trailDetail: { description: trail.description },
  trailGeoStats: { durationMinutes: trail.duration_minutes?.toString() || '0', length: trail.length || 0 }
});

export default Trail;
export { TrailId, Trail, sharedTrailFromTrail, GarminCourse };
